import { HStack, Text, Button, Spacer } from '@chakra-ui/react';
import React from 'react';
import { selectTabEnum } from './MaintenanceHeader';

interface props {
  selectTab: number;
  onOpen: () => void;
}

export const MaintenanceTitle: React.FC<props> = (props) => {
  const { selectTab, onOpen } = props;

  const GetTitle = () => {
    switch (selectTab) {
      case selectTabEnum.AdminUsers:
        return '乗務員';
      case selectTabEnum.Trains:
        return '車両';
      case selectTabEnum.TrainGroups:
        return '車両形式';
      case selectTabEnum.Category:
        return 'カテゴリ';
      case selectTabEnum.Phrases:
        return '定型文';
      case selectTabEnum.TransitLogs:
        return '発着履歴';
      case selectTabEnum.MailingList:
        return 'メーリングリスト';
      case selectTabEnum.Signages:
        return 'サイネージ';
      case selectTabEnum.Settings:
        return '初期設定';
    }
  };
  return (
    <>
      <HStack bgColor='#e5e6e7' h='20'>
        <Text ml={16} fontSize='32' color='#5e6469'>
          {GetTitle()}
        </Text>
        <Spacer />
        {selectTab !== selectTabEnum.Signages &&
          selectTab !== selectTabEnum.Settings &&
          selectTab !== selectTabEnum.TransitLogs && (
            <Button
              mr={10}
              onClick={() => onOpen()}
            >{`${GetTitle()}を作成する`}</Button>
          )}
      </HStack>
    </>
  );
};
